module.exports = __webpack_public_path__ + "static/team-7-86fb9810ac508227b3dc4472061790fb.jpg";